/** @jsxImportSource theme-ui */
import { Box } from "theme-ui";

/**
 * @param {{height: string}} props
 */
export default function Spacer({ height }) {
  return <Box sx={{ height }} />;
}
